// removed by extract-text-webpack-plugin
module.exports = {"bigButton":"_2eNKZcOtoMdsv30ASxze8M","formRow":"_2csBaKW8KijkWxKM506At9","hiddenPassword":"_2c3l0EE86tnU8vBf8-akr_","password":"_2UZqynmJiV4pe3P2z1PX8R","legalList":"_3syxuTpWjGT2_FtrRVkmkG"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/registrationPassword/registrationPasswordForm.scss
// module id = 692
// module chunks = 22